import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _isString from 'lodash/isString';
import _isObject from 'lodash/isObject';
import _noop from 'lodash/noop';

import {
  getGiftsCategories,
  getGiftsFilters,
  getProductDetails
} from 'services/gifts';
import {
  getProductsByCategory,
  getProductsByRecommendation,
  getStaticProducts,
  getDynamicRecommendation
} from 'services/recommendations';
import { hideLoader, showLoader } from 'store/actions/commons';

import { getPaginationProps } from 'util/calculations';
import { orderProductsByRule } from 'util/products';

import { MOBILE_PAGE } from 'constants/values/params';

import * as actions from './actions';

/* trae la respuesta de anteater, este deberia de cambiar para algolia */
export const fetchGiftsByFilters =
  ({
    withLoader = true,
    onlyFilters = false,
    page = 1,
    mobilePage = MOBILE_PAGE,
    onSuccess = _noop,
    onError = _noop,
    ...payload
  } = {}) =>
  async (dispatch, state) => {
    if (withLoader) dispatch(showLoader());

    dispatch(actions.fetchGiftsByFiltersRequested(payload));

    const {
      params,
      totalPages,
      totalElements,
      results = {}
    } = state.gifts.listOfGifts;

    const { prices = [] } = results;
    const paramsToFetch = { ...params };

    const filterCategoriesOfState = _get(state, 'gifts.filters.categories', []);
    const priceFilterCanBeSent = _get(
      state,
      'gifts.listOfGifts.priceFilterCanBeSent',
      false
    );

    try {
      const filterCategories = !_isEmpty(filterCategoriesOfState)
        ? filterCategoriesOfState
        : await getGiftsCategories();

      if (!priceFilterCanBeSent) {
        delete paramsToFetch.minPrice;
        delete paramsToFetch.maxPrice;
      }

      const giftsFilters = await getGiftsFilters({
        ...paramsToFetch,
        page,
        mobilePage,
        totalPages,
        totalElements,
        prices
      });

      console.log('filterCategories = service tree: ',filterCategories)
      console.log('giftsFilters = anteaterRequest: ',giftsFilters)

      giftsFilters.filters.categories = filterCategories;
      giftsFilters.page = page;
      giftsFilters.allElements = giftsFilters.listOfProducts;
      if (onlyFilters) {
        giftsFilters.list = [];
        giftsFilters.mobileList = [];
        giftsFilters.prices = prices;
        giftsFilters.allElements = results.allElements;
        delete giftsFilters.totalPages;
        delete giftsFilters.totalElements;
      }
      dispatch(actions.fetchGiftsByFiltersSuccess(giftsFilters));
      onSuccess(giftsFilters);
    } catch (error) {
      dispatch(actions.fetchGiftsByFiltersFailed(error));
      onError(error);
    } finally {
      if (withLoader) dispatch(hideLoader());
    }
};


/* respaldo */
export const fetchGiftsByFiltersResp =
  ({
    withLoader = true,
    onlyFilters = false,
    page = 1,
    mobilePage = MOBILE_PAGE,
    onSuccess = _noop,
    onError = _noop,
    ...payload
  } = {}) =>
  async (dispatch, state) => {
    if (withLoader) dispatch(showLoader());

    dispatch(actions.fetchGiftsByFiltersRequested(payload));

    const {
      params,
      totalPages,
      totalElements,
      results = {}
    } = state.gifts.listOfGifts;

    const { prices = [] } = results;
    const paramsToFetch = { ...params };

    const filterCategoriesOfState = _get(state, 'gifts.filters.categories', []);
    const priceFilterCanBeSent = _get(
      state,
      'gifts.listOfGifts.priceFilterCanBeSent',
      false
    );

    try {
      const filterCategories = !_isEmpty(filterCategoriesOfState)
        ? filterCategoriesOfState
        : await getGiftsCategories();

      if (!priceFilterCanBeSent) {
        delete paramsToFetch.minPrice;
        delete paramsToFetch.maxPrice;
      }

      const giftsFilters = await getGiftsFilters({
        ...paramsToFetch,
        page,
        mobilePage,
        totalPages,
        totalElements,
        prices
      });
      giftsFilters.filters.categories = filterCategories;
      giftsFilters.page = page;
      giftsFilters.allElements = giftsFilters.listOfProducts;
      if (onlyFilters) {
        giftsFilters.list = [];
        giftsFilters.mobileList = [];
        giftsFilters.prices = prices;
        giftsFilters.allElements = results.allElements;
        delete giftsFilters.totalPages;
        delete giftsFilters.totalElements;
      }
      dispatch(actions.fetchGiftsByFiltersSuccess(giftsFilters));
      onSuccess(giftsFilters);
    } catch (error) {
      dispatch(actions.fetchGiftsByFiltersFailed(error));
      onError(error);
    } finally {
      if (withLoader) dispatch(hideLoader());
    }
};
/* */


export const changeGiftsProductsPageAndFetch = (payload) => (dispatch) => {
  dispatch(actions.setGiftsProductsPage(payload));
  dispatch(fetchGiftsByFilters(payload));
};

export const cleanGiftsProductsParams =
  (exceptions = ['category']) =>
  (dispatch) => {
    const cleanedParams = {
      category: '',
      section: '',
      brand: '',
      highRating: false,
      maxPrice: '',
      minPrice: '',
      discount: ''
    };

    const reduceExceptions = (acc, [key, value]) => {
      if (!exceptions.includes(key)) {
        acc[key] = value;
      }
      return acc;
    };

    const paramsWithoutExceptions = Object.entries(cleanedParams).reduce(
      reduceExceptions,
      {}
    );
    dispatch(actions.setGiftsProductsParams(paramsWithoutExceptions));
  };


export const fetchProductDetails =
  (payload = {}) =>
  async (dispatch) => {
    dispatch(showLoader());

    dispatch(actions.fetchProductDetailsRequested(payload));

    try {
      const response = await getProductDetails(
        _isString(payload) ? payload : payload.productId
      );
      console.log('getProductDetails = service api product: ',response)
      dispatch(actions.fetchProductDetailsSuccess(response));
      if (_isObject(payload) && payload.onSuccess) payload.onSuccess(response);
    } catch (error) {
      dispatch(actions.fetchProductDetailsFailed(error));
      if (_isObject(payload) && payload.onError) payload.onError(error);
    } finally {
      dispatch(hideLoader());
    }
};


export const fetchProductsOfSelectedCategory =
  (payload) => async (dispatch, state) => {
    const selectedCategory = payload || state.gifts.selectedCategory;

    const params = _get(state, 'gifts.listOfGifts.params', {});

    if (_isEmpty(selectedCategory)) return;

    dispatch(showLoader());

    dispatch(actions.fetchProductsOfSelectedCategoryRequested(payload));

    try {
      const productsByCategory = await getProductsByCategory(selectedCategory, {
        ...params,
        page: 1
      });

      console.log('productsByCategory: ',productsByCategory)
      dispatch(
        actions.fetchProductsOfSelectedCategorySuccess(productsByCategory)
      );
    } catch (error) {
      dispatch(actions.fetchProductsOfSelectedCategoryFailed(error));
    } finally {
      dispatch(hideLoader());
    }
  };

const recommendationsNotFound = (dispatch) => {
  dispatch(actions.setShowRecommendations(false));
  dispatch(actions.setWithRecommendations(false));
  throw new Error('Products not found');
};

export const fetchProductsByRecommendations =
  (payload) => async (dispatch, state) => {
    dispatch(showLoader());

    const eventId =
      payload || _get(state, 'giftTable.giftTableInfo.data.type.id', '');
    const params = _get(state, 'gifts.listOfGifts.params', {});

    dispatch(actions.fetchProductsByRecommendationsRequest(payload));

    try {
      const [categories, products] = await getProductsByRecommendation(
        eventId,
        { ...params, page: 1 }
      );
      console.log('getProductsByRecommendation: ',)

      if (products.length === 0) {
        recommendationsNotFound(dispatch);
      }

      const staticProducts = await getStaticProducts({
        products,
        ...params
      });

      const [defaultCategory] = categories;

      dispatch(actions.setShowRecommendations(true));
      dispatch(
        actions.fetchProductsByRecommendationsSuccess({
          categories,
          allProducts: products,
          defaultCategory
        })
      );
      dispatch(actions.fetchProductsOfSelectedCategorySuccess(staticProducts));
    } catch (error) {
      console.error(error);
      dispatch(actions.fetchProductsByRecommendationsFailed(error));
    } finally {
      dispatch(hideLoader());
    }
  };

export const fetchAllProductsOfRecommendations =
  (payload = {}) =>
  async (dispatch, state) => {
    const { hasDynamic = false } = payload;

    if (!hasDynamic) dispatch(showLoader());

    const defaultConfiguration = _get(
      state,
      'gifts.dynamicRecommendation.data.configurations[0]',
      {}
    );

    try {
      if (!hasDynamic) {
        dispatch(actions.fetchProductsOfSelectedCategoryRequested(payload));

        const staticProducts = await getStaticProducts({
          state,
          cleanParams: true
        });

        dispatch(
          actions.fetchProductsOfSelectedCategorySuccess(staticProducts)
        );
      } else {
        // When is dynamic recommendation this action is responsible of hide loader
        dispatch(
          actions.fetchProductsOfDynamicCategoryRequested(defaultConfiguration)
        );
      }
    } catch (error) {
      if (!hasDynamic)
        dispatch(actions.fetchProductsOfSelectedCategoryFailed(error));
      dispatch(hideLoader());
    } finally {
      if (!hasDynamic) dispatch(hideLoader());
    }
  };

export const fetchDynamicConfiguration = (payload) => async (dispatch) => {
  try {
    dispatch(showLoader());

    dispatch(actions.fetchDynamicConfigurationRequested(payload));

    const { eventTypeId, guestRangeId } = payload;
    const [dynamicConfiguration, recommendationRules] =
      await getDynamicRecommendation(eventTypeId, guestRangeId);

    if (dynamicConfiguration.configurations.length === 0) {
      recommendationsNotFound(dispatch);
    }

    const [defaultConfig] = dynamicConfiguration.configurations;

    const data = {
      ...dynamicConfiguration,
      rules: recommendationRules
    };
    dispatch(actions.setRecommendedCategory(defaultConfig));
    dispatch(actions.fetchDynamicConfigurationSuccess(data));
  } catch (error) {
    console.error(error);
    dispatch(actions.fetchDynamicConfigurationFailed(error));
  } finally {
    dispatch(hideLoader());
  }
};

export const fetchProductsOfDynamicCategory =
  (payload) => async (dispatch, state) => {
    dispatch(showLoader());

    dispatch(actions.fetchProductsOfDynamicCategoryRequested(payload));

    const { rules, guestRange = {}, category_sears_id } = payload;

    const {
      params: listParams,
      totalPages: listTotalPages,
      totalElements: listTotalElements
    } = state.gifts.listOfGifts;

    try {
      const page = 1;

      const params = {
        page,
        size: guestRange.product_quantity,
        mobilePage: page,
        mobileSize: guestRange.product_quantity,
        category: category_sears_id,
        sort: rules.value,
        start: 0,
        stockStart: true
      };

      const { listOfProducts = [] } = await getGiftsFilters({
        ...params,
        totalPages: listTotalPages,
        totalElements: listTotalElements
      });

      if (listOfProducts.length === 0) {
        recommendationsNotFound(dispatch);
      }

      const pagination = getPaginationProps(
        listOfProducts,
        listParams.size,
        page,
        listParams.mobileSize,
        listParams.mobilePage
      );

      dispatch(actions.setShowRecommendations(true));

      dispatch(actions.fetchProductsOfDynamicCategorySuccess(pagination));
    } catch (error) {
      console.error('error', error);
      dispatch(actions.fetchProductsOfDynamicCategoryFailed(error));
    } finally {
      dispatch(hideLoader());
    }
  };

export const changeRecommendationProductsPage =
  ({ hasDynamic, ...payload } = {}) =>
  async (dispatch, state) => {
    const { results = {}, params = {} } = state.gifts.listOfGifts;

    let recommendationProducts = {};

    // for static recommendations we need to fetch next page of products
    if (!hasDynamic) {
      try {
        dispatch(showLoader());

        const staticProducts = await getStaticProducts({
          state,
          page: payload.page,
          size: params.size,
          mobilePage: payload.mobilePage,
          mobileSize: params.mobileSize
        });

        recommendationProducts = {
          ...staticProducts,
          ...staticProducts.params
        };
      } catch (error) {
        console.error('error', error);
      } finally {
        dispatch(hideLoader());
      }
    } else {
      const { allElements = [] } = results;
      const { size, mobileSize, sortAddProducts } = params;

      recommendationProducts = getPaginationProps(
        allElements,
        size,
        payload.page,
        mobileSize,
        payload.mobilePage
      );

      const desktopOrderList = orderProductsByRule(
        recommendationProducts.list,
        sortAddProducts
      );

      const mobileOrderList = orderProductsByRule(
        recommendationProducts.mobileList,
        sortAddProducts
      );

      recommendationProducts.list = desktopOrderList;
      recommendationProducts.mobileList = mobileOrderList;
    }

    dispatch(
      actions.changeRecommendationProductsPage({
        ...recommendationProducts,
        ...recommendationProducts.params
      })
    );
  };

export const changeRecommendationProductsOrder =
  (payload) => (dispatch, state) => {
    const { results = {}, params = {} } = state.gifts.listOfGifts;
    const { list: products = [] } = results;

    const pagination = getPaginationProps(
      results.allElements,
      params.size,
      params.page,
      params.mobileSize,
      params.mobilePage
    );

    const desktopOrderList = orderProductsByRule(
      products,
      payload,
      pagination.list
    );

    const mobileOrderList = orderProductsByRule(
      products,
      payload,
      pagination.list
    );

    if (!desktopOrderList || !mobileOrderList) return;

    dispatch(
      actions.changeRecommendationProductsOrder({
        list: desktopOrderList,
        mobileList: mobileOrderList
      })
    );
  };
